import moment from 'moment';

export const timestampForFileName= ({d = new Date()}) => {

    const start = moment(d).format("MM-DD-YYYY_HH-mm-ss_A");
    return start.replace(':','_')

}

export function formatRemainingTime(endTime) {

    const timeRemaining = getTimeRemaining(endTime);
    var remaining = '';
    if (timeRemaining.days) {
        remaining += timeRemaining.days + ' day';
        if (timeRemaining.days > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.hours) {
        remaining += timeRemaining.hours + ' hour';
        if (timeRemaining.hours > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.minutes) {
        remaining += timeRemaining.minutes + ' minute';
        if (timeRemaining.minutes > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.seconds) {
        remaining += timeRemaining.seconds + ' second';
        if (timeRemaining.seconds > 1)
            remaining += 's';
        remaining += ' ';
    }


    return remaining;

}

function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}


/**
 * Adds local time strings to an object in the local time zone,
 * recurses too...
 *
 * @param obj
 */
export function addLocalTimeStrings(obj) {

    Object.keys(obj).forEach(function (key) {
        // console.log('Checking attr ' + key);
        // console.log('value ' + obj[key]);
        // console.log('type ' + typeof(obj[key]));
        if (isValidDate(obj[key])) {
            // console.log('Is Date ' + key)
            const keyNew = key + "_formattedLocal"
            obj[keyNew] = obj[key].toLocaleString();
        }
        else if (typeof obj[key] === 'object') {
            return addLocalTimeStrings(obj[key]);
        }
        else {
            // console.log('Not A Date ' + key)
        }
    });
    return obj;

}
export function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}